const ERPCN = [
    { name: "adultPrice", type: "BigDecimal", desc: "订单成人销售单价" },
    { name: "backDate", type: "String", desc: "回程日期" },
    { name: "bookingInfo", type: "String", desc: "预订须知" },
    { name: "clientPeerAddress", type: "String", desc: "渠道/门店地址" },
    { name: "clientPeerMobile", type: "String", desc: "渠道/门店联系方式" },
    { name: "clientPeerName", type: "String", desc: "渠道/门店名称" },
    { name: "contractMoney", type: "BigDecimal", desc: "合同总金额" },
    { name: "days", type: "Integer", desc: "天数" },
    { name: "feeExclude", type: "String", desc: "费用不包含" },
    { name: "feeInclude", type: "String", desc: "费用包含" },
    { name: "feeIntroduce", type: "String", desc: "费用说明" },
    { name: "limitedNum", type: "Integer", desc: "最低成团人数" },
    { name: "localAgentName", type: "String", desc: "地接社名称" },
    { name: "needBedChildAge", type: "Integer", desc: "占床儿童年龄" },
    { name: "needBedChildPrice", type: "BigDecimal", desc: "订单占床儿童销售单价" },
    { name: "nights", type: "Integer", desc: "晚数" },
    { name: "notNeedBedChildAge", type: "Integer", desc: "不占床儿童年龄" },
    { name: "notNeedBedChildPrice", type: "BigDecimal", desc: "订单不占床儿童销售单价" },
    { name: "notes", type: "String", desc: "注意事项" },
    { name: "orderDate", type: "String", desc: "预定日期" },
    { name: "outlineTravel", type: "String", desc: "行程简介" },
    { name: "payDate", type: "String", desc: "取值订单支付日期" },
    { name: "payWay", type: "String", desc: "订单支付方式" },
    { name: "peopleNum", type: "Integer", desc: "游客人数" },
    { name: "productName", type: "String", desc: "产品名称/团队名称" },
    { name: "saleMan", type: "String", desc: "订单销售员" },
    { name: "teamNo", type: "String", desc: "团号" },
    { name: "touristNames", type: "List<String>", required: "否", desc: "游客姓名" },
    { name: "travelCharacteristic", type: "String", desc: "行程特色" },
    { name: "unsubscribeInfo", type: "String", desc: "退订须知" },
    { name: "useDate", type: "String", desc: "出发日期" },
    { name: "dailyScheduleList", type: "List<DailyScheduleDto>", desc: "日程" },
    { name: "touristDtos", type: "List<TouristDto>", desc: "游客名单" },

    { name: "DailyScheduleDto.day", type: "Integer", desc: "第几天" },
    { name: "DailyScheduleDto.destination", type: "String", desc: "目的地" },
    { name: "DailyScheduleDto.scheduleDesc", type: "String", desc: "日程描述" },
    { name: "DailyScheduleDto.starting", type: "String", desc: "出发地" },
    { name: "DailyScheduleDto.teamActivitySingleList", type: "List<SingleDto>", desc: "活动单项" },
    { name: "DailyScheduleDto.teamBusSingleList", type: "List<SingleDto>", desc: "线路用车单项" },
    { name: "DailyScheduleDto.teamFlightSingleList", type: "List<SingleDto>", desc: "线路航班单项" },
    { name: "DailyScheduleDto.teamFreeTimeSingleList", type: "List<SingleDto>", desc: "自由活动单项" },
    { name: "DailyScheduleDto.teamHotelSingleList", type: "List<SingleDto>", desc: "线路酒店单项" },
    { name: "DailyScheduleDto.teamMealSelfPaidList", type: "List<SingleDto>", desc: "其他餐食" },
    { name: "DailyScheduleDto.teamMealSingleAfternoonTea", type: "SingleDto", desc: "每日餐食单项：下午茶" },
    { name: "DailyScheduleDto.teamMealSingleBreakfast", type: "SingleDto", desc: "每日餐食单项：早餐" },
    { name: "DailyScheduleDto.teamMealSingleDinner", type: "SingleDto", desc: "每日餐食单项：晚餐" },
    { name: "DailyScheduleDto.teamMealSingleLunch", type: "SingleDto", desc: "每日餐食单项：午餐" },
    { name: "DailyScheduleDto.teamMealSingleNightSnack", type: "SingleDto", desc: "每日餐食单项：夜宵" },
    { name: "DailyScheduleDto.teamOtherSingleList", type: "List<SingleDto>", desc: "线路其他单项" },
    { name: "DailyScheduleDto.teamScenicSpotSingleList", type: "List<SingleDto>", desc: "景区单项" },
    { name: "DailyScheduleDto.teamShipSingleList", type: "List<SingleDto>", desc: "轮船单项" },
    { name: "DailyScheduleDto.teamShopSingleList", type: "List<SingleDto>", desc: "线路购物店单项" },
    { name: "DailyScheduleDto.teamTrainSingleList", type: "List<SingleDto>", desc: "线路火车单项" },

    { name: "SingleDto.itemDesc", type: "String", desc: "描述" },
    { name: "SingleDto.itemTimeSpan", type: "Integer", desc: "单项时长" },
    { name: "SingleDto.itemTimeStart", type: "String", desc: "开始时间" },
    { name: "SingleDto.name", type: "String", desc: "名称" },
    { name: "SingleDto.planPrice", type: "String", desc: "参考价格" },
    { name: "SingleDto.singleInfo", type: "Integer", desc: "单项信息：1=包含、2=自理、3=自费" },

    { name: "TouristDto.touristName", type: "String", desc: "游客名称" },
    { name: "TouristDto.cardNo", type: "String", desc: "证件号" },
    { name: "TouristDto.age", type: "Integer", desc: "年龄" },
    { name: "TouristDto.address", type: "String", desc: "所在地" },
    { name: "TouristDto.birthday", type: "String", desc: "出生日期" },
    { name: "TouristDto.cardTypeName", type: "String", desc: "证件类型" },
    { name: "TouristDto.isLinkMan", type: "Boolean", desc: "是否是联系人" },
    { name: "TouristDto.mobile", type: "String", desc: "手机号" },
    { name: "TouristDto.price", type: "BigDecimal", desc: "价格" },
    { name: "TouristDto.remark", type: "String", desc: "备注" },
    { name: "TouristDto.sex", type: "String", desc: "性别" }
]

const QUXCN = [
    { name: "companyName", type: "String", desc: "签署公司名称" },
    { name: "companyBusinessNo", type: "String", desc: "签署公司经营许可证号" },
    { name: "companyBusinessAddress", type: "String", desc: "签署公司经营地址" },
    { name: "touristNum", type: "String", desc: "人数" },
    { name: "useDate", type: "String", desc: "出团日期" },
    { name: "returnDate", type: "String", desc: "回程日期" },
    { name: "dayNum", type: "String", desc: "天数" },
    { name: "price", type: "String", desc: "单价" },
    { name: "extraPrice", type: "String", desc: "附加服务单价" },
    { name: "orderMoney", type: "String", desc: "订单金额" },
    { name: "minGroupNum", type: "String", desc: "成团人数" },
    { name: "remark", type: "String", desc: "订单备注" },
    { name: "contactPhone", type: "String", desc: "订单联系人电话" },
    { name: "salemanName", type: "String", desc: "分销员姓名" },
    { name: "salemanPhone", type: "String", desc: "分销员电话" },
    { name: "productId", type: "String", desc: "商品编号" },
    { name: "tourists", type: "List<Tourist>", desc: "商品编号" },

    { name: "Tourist.name", type: "String", desc: "游客名称" },
    { name: "Tourist.cardTypeName", type: "String", desc: "证件类型" },
    { name: "Tourist.cardNo", type: "String", desc: "证件号" },
    { name: "Tourist.mobile", type: "String", desc: "手机号" },
    { name: "Tourist.birthday", type: "String", desc: "出生日期" },
    { name: "Tourist.sex", type: "String", desc: "性别" }
]

export default { ERPCN, QUXCN }